import Loader from 'components/loader/Loader';
import { Outlet, useOutletContext } from 'react-router-dom';
import useFetchScreenAndProtectEnrollment from './useFetchScreenAndProtectEnrollment';
import { ScreenAndProtectOutletContext } from './ScreenAndProtect.types';

const ScreenAndProtect = () => {
  const { isEnrolled, propertiesUids, activeSince, isLoading } =
    useFetchScreenAndProtectEnrollment();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Outlet
      context={
        {
          isEnrolled,
          propertiesUids,
          activeSince,
        } satisfies ScreenAndProtectOutletContext
      }
    />
  );
};

export function useScreenAndProtectContext() {
  const context = useOutletContext<ScreenAndProtectOutletContext>();

  if (!context) {
    return {
      isEnrolled: false,
      propertiesUids: [],
      activeSince: null,
    } satisfies ScreenAndProtectOutletContext;
  }

  return context;
}

export default ScreenAndProtect;
